import React from 'react';
import { useAuth } from '../components/AuthProvider';
import { useNavigate } from 'react-router-dom';
import OrderManagement from './OrderManagement';
import { useOrderNotifications } from '../hooks/useOrderNotifications';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';
import LanguageSwitcher from '../components/LanguageSwitcher';

const AdminOrders: React.FC = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(key as any, language);
  useOrderNotifications();

  return (
    <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 50%, #bbf7d0 100%)'}}>
      <nav className="bg-white/90 backdrop-blur-md shadow-soft" style={{borderBottom: '1px solid #05472A20'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 sm:py-0 sm:h-20 gap-4 sm:gap-0">
            <div className="flex items-center">
              <div className="w-10 h-10 rounded-xl mr-3 flex items-center justify-center shadow-lg overflow-hidden" style={{backgroundColor: '#05472A'}}>
                <img 
                  src="https://edu.almuwasholah.com/wp-content/uploads/2026/02/logo-habib-1.png"
                  alt="Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <h1 className="text-xl sm:text-2xl font-bold" style={{color: '#05472A'}}>{t('orderManagement')}</h1>
            </div>
            <div className="flex items-center gap-2 sm:gap-4">
              <LanguageSwitcher />
              <button onClick={() => navigate('/admin')} className="bg-white hover:bg-green-50 border px-4 py-2 sm:px-6 sm:py-3 rounded-xl font-semibold transition-all duration-300 shadow-soft hover:shadow-medium text-sm" style={{color: '#05472A', borderColor: '#05472A40'}}>
                {t('back')}
              </button>
              <span className="hidden lg:block text-sm" style={{color: '#05472A'}}>{t('admin')}: {user?.username}</span>
              <button onClick={signOut} className="bg-white hover:bg-green-50 border px-3 py-2 sm:px-4 sm:py-2 rounded-xl font-semibold transition-all duration-300 shadow-soft hover:shadow-medium text-sm" style={{color: '#05472A', borderColor: '#05472A40'}}>
                <span className="hidden sm:inline">{t('signOut')}</span>
                <svg className="w-4 h-4 sm:hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto py-6 sm:py-8 px-4 sm:px-6 lg:px-8">
        <OrderManagement />
      </main>
    </div>
  );
};

export default AdminOrders;
